import AxiosApi from './AxiosApi';
import { config } from '../Constants'

class LocalizacaoService {
    
    postLocalizacao(id,loc) {

        const dados = {
            idEnderecoAssistencia: id,
            latitude: loc.lat,
            longitude: loc.lng
        }        

        const conf = {
            headers: {
                    'chave' : config.url.CHAVE,
                    'token' : config.url.TOKEN,
                    //'idClienteCorporativo': config.url.ID_CLIENTECORPORATIVO,
                    'idTipoCarteira' : "1",
                    'Content-Type' : 'application/json',
                    'accept' : 'application/json',
                    'Authorization' : config.url.AUTHORIZATION
                    }
          };
        
        return AxiosApi.post('/endereco/montarEnderecoAssistencia', 
            dados,
            conf,
            ).then(res => (res.data));
    }

    getEndereco(loc) {
        const conf = {
            headers: {
                    'chave' : config.urlEnd.CHAVE,
                    'token' : config.urlEnd.TOKEN,
                    'idClienteCorporativo': config.urlEnd.IDCLIENTECORPORATIVO,
                    'Authorization' : config.urlEnd.AUTHORIZATION,
                    'idTipoCarteira' : "1",
                    'Content-Type' : 'application/json',
                    }
          };
        
        return AxiosApi.get(`${config.urlEnd.API_URL}/${loc.lat}/${loc.lng}`,
            conf,
            ).then(res => (res.data));
    }

}

export default LocalizacaoService;